module.exports = __webpack_public_path__ + "img/avatar-38.a269d1ca.png";